var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.885 5.5265C28.219 4.8286 31.7017 4.80657 35.1122 5.51962C35.5547 8.4185 37.262 11.0973 39.9992 12.6776C42.7362 14.2578 45.91 14.3971 48.6415 13.3307C50.9645 15.9279 52.6867 18.9551 53.7492 22.1913C51.463 24.0239 49.9992 26.84 49.9992 29.998C49.9992 33.158 51.4647 35.9755 53.7532 37.808C53.225 39.409 52.526 40.9805 51.6497 42.498C50.7735 44.0157 49.7622 45.4067 48.6397 46.6647C45.9085 45.599 42.7357 45.7387 39.9992 47.3185C37.2642 48.8975 35.5575 51.5735 35.1132 54.4697C31.7795 55.1675 28.2967 55.1895 24.8861 54.4765C24.4437 51.5777 22.7363 48.8987 19.9992 47.3185C17.2621 45.7382 14.0885 45.599 11.3568 46.6655C9.03392 44.0682 7.31164 41.041 6.24909 37.8047C8.53529 35.9722 9.99919 33.156 9.99919 29.998C9.99919 26.8382 8.53359 24.0207 6.24512 22.1881C6.77332 20.587 7.47234 19.0157 8.34854 17.4981C9.22477 15.9804 10.2361 14.5894 11.3585 13.3314C14.0898 14.397 17.2627 14.2575 19.9992 12.6776C22.7341 11.0985 24.441 8.42275 24.885 5.5265ZM29.9992 37.498C34.1412 37.498 37.4992 34.1402 37.4992 29.998C37.4992 25.856 34.1412 22.4981 29.9992 22.4981C25.857 22.4981 22.4992 25.856 22.4992 29.998C22.4992 34.1402 25.857 37.498 29.9992 37.498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.7406a5a5257da2c817dc65f6447f27b1.svg";
export { ForwardRef as ReactComponent };